import React, { Component, Dispatch } from 'react';
import { IResetPasswordProps, ILoginAfterProps } from '../../models/pages/login';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/login';
import { Input } from '../../components/input/text/main';
import Loading from '../../components/loading/loading';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { Button } from '../../components/ui-elements/main';
const T = Translator.create();
const _logger = Log.create('reset-password-form.tsx');
class ResetPasswordForm extends React.Component<IResetPasswordProps> {
    public userName: string | null = null;
    public refForm: HTMLFormElement | null = null;

    constructor(props: IResetPasswordProps) {
        super(props);
    }

    public checkUser = (event: any) => {
        event.preventDefault();
        if (this.userName) {
            this.dispachMyForgotPassword(this.userName);
        }
    };

    public onChangeUserName = (event: string) => {
        this.userName = event;
    };

    public onBackClick = () => {
        this.props.dispatch(Actions.setCurrentPage('Login', ''));
    };

    public dispachMyForgotPassword = (searchedUser: string) => {
        if (this.refForm && this.refForm.checkValidity()) {
            this.props.dispatch(Actions.myForgotPasswordGetAction(searchedUser, 'myForgotPasswordGetAction', 'get'));
        }
    };

    public render() {
        return (
            <div>
                {
                    <div className="animated fadeIn">
                        <h1>{T.t('r_my_forgot_password_comment_title')}</h1>
                        <p>{T.t('r_my_forgot_password_comment_content')} </p>
                        <form ref={e => (this.refForm = e)} noValidate={false} onSubmit={this.checkUser}>
                            <Input
                                type="text"
                                required={true}
                                onChange={this.onChangeUserName}
                                placeHolder={T.t('r_my_forgot_password_input_placeholder')}
                                maxLenght={50}
                                minLenght={1}
                            />
                            <div className="row align-items-center mt-3">
                                <div className="col">
                                    <a onClick={this.onBackClick} className=" d-flex align-items-center ">
                                        <i className="material-icons mr-1">keyboard_backspace</i> {T.t('r_my_forgot_password_back')}
                                    </a>
                                </div>
                                <div className="col text-right">
                                    <Button
                                        button_type="primary"
                                        type="submit"
                                        size="medium"
                                        text={T.t('r_my_forgot_password_check_user_button')}
                                    ></Button>
                                </div>
                            </div>
                        </form>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IResetPasswordProps) => {
    if (!state) {
        return ownProps;
    }
    // tslint:disable-next-line: one-variable-per-declaration
    const newProps: IResetPasswordProps = Object.assign({}, ownProps, {
        haveUser: state.login.login.haveUser,
        isQuestion: state.login.login.isQuestion,
        passwordSecurtiyQuestion: state.login.login.passwordSecurtiyQuestion,
        resetPasswordLoading: state.login.login.resetPasswordLoading,
        currentPage: state.login.login.currentPage
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({
    dispatch
});

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        // next.login.login.resetPasswordLoading === prev.login.login.resetPasswordLoading &&
        next.login.login === prev.login.login && next.login.login.currentPage === prev.login.login.currentPage;
    return ret;
};

const CResetPasswordForm = connect(mapStateToProps, dispatchProps)(ResetPasswordForm);

export default CResetPasswordForm;
